import { fromLonLat } from "./mercator";
import { setAlertText, setPlace, setPoint } from "../features/map/mapSlice";

// Kept apart from Map.js, which loads all of OpenLayers, so the landing page's
// place search can use it without pulling in the map
export function getUserLocation(dispatch, showAlert=false) {
    navigator.geolocation.getCurrentPosition(
      function(pos) {
          let lon = pos.coords.longitude;
          let lat = pos.coords.latitude;
          //-6.416016,49.823809,2.702637,55.751849
          //Are we in the UK?
          if (lon>=-8.948190346097487 && lon<=2.267968716721079 && lat>=49.823809 && lat<=59.58730581272295) {
            let lonlat = fromLonLat([lon, lat]);
            let userPoint = {x:lonlat[0], y:lonlat[1]};            
            dispatch(setPlace(''));
            dispatch(setPoint(userPoint));
          }        
          else {            
            if (showAlert) {
                dispatch(setAlertText('Data only available for the UK'));
            }
          }
        },
      function (error) {
          //showAlert(`${error.message}`);
          console.log(`ERROR: ${error.message}`);
      },
      {
          enableHighAccuracy:true,
      }
  );
  }
